export const checkScrollableParentOf = (element: HTMLElement | null, breakSearchCb: (el: HTMLElement) => boolean): boolean => {
  if (element === null) {
    return false;
  }

  // WARNING!
  // If the element has no associated CSS layout box or if the CSS layout box is inline, clientHeight return zero.

  if (element.tagName === 'SPAN') {
    const style = window.getComputedStyle(element);

    if (style.display === 'inline') {
      return checkScrollableParentOf(element.parentElement, breakSearchCb);
    }
  }

  if (element.scrollHeight > element.clientHeight && element.scrollTop > 0) {
    return true;
  }

  // Check should we break our recursive search
  if (breakSearchCb && breakSearchCb(element)) {
    return false;
  }

  return checkScrollableParentOf(element.parentElement, breakSearchCb);
};
